import React from 'react';
import { colors } from 'app/shared/theme/colors';
import { useTranslation } from 'app/shared/i18n';

export const RegisterMail = () => {
  const { t } = useTranslation();

  return (
    <div style={{ maxWidth: 600, margin: '0 auto', padding: '36px 24px' }}>
      <h2 style={{ fontSize: 22, fontWeight: 700, marginBottom: 24, display: 'flex', alignItems: 'center', gap: 10 }}>
        {t('toolRegisterMail.title')}
      </h2>
      <div className="ms-card" style={{ padding: 40, textAlign: 'center' }}>
        <div style={{ fontSize: 48, opacity: 0.2, marginBottom: 12 }}>🚧</div>
        <div style={{ fontSize: 16, fontWeight: 600, color: colors.dim }}>{t('toolSuspended.title')}</div>
        <div style={{ fontSize: 13, color: colors.dim, marginTop: 8, opacity: 0.7 }}>{t('toolSuspended.contactAdmin')}</div>
        <a
          href="https://t.me/q8tools"
          target="_blank"
          rel="noreferrer"
          className="ms-btn ms-btn--ghost"
          style={{ marginTop: 20, display: 'inline-flex' }}
        >
          {t('toolSuspended.contactTelegram')}
        </a>
      </div>
    </div>
  );
};
